import { selectBoots, euSize } from './thioufoot-advisor-engine.js';

class ThioufootAdvisor extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const data = this.querySelector('[data-advisor-data]');
    if (!data) return;
    this.data = JSON.parse(data.textContent);
    this.data.products.forEach(product => {
      product.name = product.name.replace(/&#39;|&apos;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim();
    });
    this.form = this.querySelector('form');
    this.steps = [...this.querySelectorAll('[data-step]')];
    this.results = this.querySelector('[data-results]');
    this.step = 0;
    this.shown = 3;
    this.querySelector('[data-enhanced]').hidden = false;
    this.querySelector('[data-fallback]').hidden = true;
    this.addEventListener('click', event => {
      if (event.target.closest('[data-next]')) this.next();
      if (event.target.closest('[data-back]')) this.showStep(this.step - 1);
      if (event.target.closest('[data-edit]')) {
        this.results.hidden = true;
        this.form.hidden = false;
        this.showStep(0);
      }
      if (event.target.closest('[data-more]')) {
        this.shown = this.matches.length;
        this.renderCards();
        this.querySelector('[data-more]').hidden = true;
      }
    });
    this.form.addEventListener('submit', event => {
      event.preventDefault();
      if (this.step < this.steps.length - 1) return this.next();
      this.finish();
    });
    this.showStep(0, false);
  }

  showStep(index, focus = true) {
    this.step = Math.min(Math.max(index, 0), this.steps.length - 1);
    this.steps.forEach((step, i) => { step.hidden = i !== this.step; });
    this.querySelector('[data-back]').hidden = this.step === 0;
    this.querySelector('[data-next]').hidden = this.step === this.steps.length - 1;
    this.querySelector('[data-submit]').hidden = this.step !== this.steps.length - 1;
    this.querySelector('progress').value = this.step + 1;
    this.querySelector('[data-step-count]').textContent = `${this.step + 1} / ${this.steps.length}`;
    if (focus) this.steps[this.step].querySelector('legend').focus();
  }

  next() {
    const invalid = [...this.steps[this.step].querySelectorAll('input,select')].find(input => !input.checkValidity());
    if (invalid) return invalid.reportValidity();
    this.showStep(this.step + 1);
  }

  finish() {
    const values = Object.fromEntries(new FormData(this.form));
    this.profile = values;
    this.matches = selectBoots(this.data.products, values);
    this.shown = 3;
    this.form.hidden = true;
    this.results.hidden = false;
    const text = this.data.text;
    this.querySelector('[data-result-count]').textContent = this.matches.length ? (this.matches.length === 1 ? text.count_one : text.count).replace('[count]', this.matches.length) : text.empty;
    const terrainLabel = this.form.querySelector(`input[name="ground"][value="${values.ground}"]`).parentElement;
    const selectedTerrain = `${terrainLabel.querySelector('strong').textContent} (${values.ground.toUpperCase()})`;
    this.querySelector('[data-profile-summary]').textContent = `${selectedTerrain} · EU ${values.size}${Number(values.budget) > 0 ? ` · ${text.max_budget} ${values.budget} €` : ''}`;
    const notes = [];
    if (values.width === 'wide') notes.push(text.wide_note);
    if (values.width === 'narrow') notes.push(text.narrow_note);
    if (['tight', 'loose'].includes(values.oldFit)) notes.push(text.old_fit_note);
    const oldSize = euSize(values.oldSize);
    if (oldSize !== null && Math.abs(oldSize - euSize(values.size)) > 0.02) notes.push(text.changed_size);
    if (values.oldModel.trim() || values.oldSize.trim()) {
      const reference = [values.oldBrand === 'other' ? '' : values.oldBrand, values.oldModel.trim(), values.oldSize.trim()].filter(Boolean).join(' · ');
      notes.unshift(`${text.previous_pair} ${reference}`);
    }
    this.querySelector('[data-fit-note]').textContent = notes.join(' ');
    this.querySelector('[data-fit-note]').hidden = !notes.length;
    this.querySelector('[data-empty]').hidden = this.matches.length > 0;
    this.querySelector('[data-more]').hidden = this.matches.length <= this.shown;
    this.renderCards();
    this.results.querySelector('h2').focus();
  }

  renderCards() {
    const container = this.querySelector('[data-cards]');
    container.replaceChildren();
    const template = this.querySelector('template');
    for (const product of this.matches.slice(0, this.shown)) {
      const fragment = template.content.cloneNode(true);
      const card = fragment.querySelector('article');
      const link = card.querySelector('a');
      const url = new URL(product.url, location.origin);
      url.searchParams.set('variant', String(product.variant.id));
      link.href = url.pathname + url.search;
      card.querySelector('h3').textContent = product.name;
      const img = card.querySelector('img');
      if (product.image) { img.src = product.image; img.alt = product.name; } else img.remove();
      card.querySelector('[data-card-size]').textContent = product.variant.title;
      card.querySelector('[data-card-price]').textContent = new Intl.NumberFormat(this.data.locale, { style: 'currency', currency: this.data.currency }).format(product.variant.price / 100);
      const reasons = [this.data.text.right_ground, this.data.text.in_size];
      for (const reason of product.reasons) if (this.data.text[reason]) reasons.push(this.data.text[reason]);
      card.querySelector('[data-card-reason]').textContent = reasons.join(' · ');
      container.append(fragment);
    }
  }
}

if (!customElements.get('thioufoot-advisor')) customElements.define('thioufoot-advisor', ThioufootAdvisor);

